import { render, staticRenderFns } from "./set_privacySetting.vue?vue&type=template&id=131d8238&scoped=true"
import script from "./set_privacySetting.vue?vue&type=script&lang=js"
export * from "./set_privacySetting.vue?vue&type=script&lang=js"
import style0 from "./set_privacySetting.vue?vue&type=style&index=0&id=131d8238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d8238",
  null
  
)

export default component.exports